export const getMenu = (state) => state.layout.menu;
export const getStatus = (state) => state.layout.status;
